import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { SplitButton } from "primereact/splitbutton";
import { Checkbox } from "primereact/checkbox";
import { Toolbar } from "primereact/toolbar";
import { Util, timesheetApi } from "../../services";
import { settingService } from "../../services/extensions";
import { toast } from "react-toastify";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import { Fieldset } from "primereact/fieldset";
import EmailDialogForm from "./dialogBox/invoiceEmailForm";
import { userService } from "../../services/extensions";
import FileSaver from "file-saver";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import { MultiSelect } from "primereact/multiselect";
import { TIMESHEET_INVOICE_VIEW, TIMESHEET_INVOICE_UNLOCK } from '../../config/permissions';
import { hasPermission } from "../../components/protected/ProtectedSection";
import ProtectedSection from "../../components/protected/ProtectedSection";
import { confirmDialog } from "primereact/confirmdialog";

const InvoiceTimesheet = () => {
  const dt = useRef(null);
  const [emailDialog, setEmailDialog] = useState(false);
  const [rowClick, setRowClick] = useState(false);
  const [emailPayload, setEmailPayload] = useState('');
  const [checked, setChecked] = useState(false);
  const [invoiceTimesheetList, setInvoiceTimesheetList] = useState([]);
  const [invoiceFilterTimesheetList, setInvoiceFilterTimesheetList] = useState([]);
  const [selectedInvoiceTimesheet, setSelectedInvoiceTimesheet] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [teamMember, setTeamMember] = useState(null);
  const [allocatedProjectData, setAllocatedProjectData] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [expandedChildInvoiceRows, setExpandedChildInvoiceRows] = useState(null);
  const [lockUnlockDisabled, setLockUnlockDisabled] = useState(true);
  const [exportDisabled, setExportDisabled] = useState(true);
  const [errorLog, SetErrorLog] = useState(false);
  const [invoiceDetailsDialog, setInvoiceDetailsDialog] = useState(false);
  const [invoiceRowData, setInvoiceRowData] = useState([]);
  const [invoiceRowIndex, setInvoiceRowIndex] = useState("");
  const [showCalender, setShowCalender] = useState(false);
  const [currMonth, setCurrMonth] = useState(new Date());
  const [dateFilter, setDateFilter] = useState(false);
  const [invoiceSDate, setInvoiceSDate] = useState("");
  const [invoiceEDate, setInvoiceEDate] = useState("");
  const [allUsersEmail, setAllUsersEmail] = useState([]);
  const [lockStatus, setLockStatus] = useState(false);
  const [mgrDialog, setMgrDialog] = useState(false);
  const [allocationMessage, setAllocationMessage] = useState([]);
  const [projectIdsList, setProjectIdsList] = useState([]);
  const filterStatusList = [{ name: "LOCKED", code: "LOCKED" }, { name: "UNLOCKED", code: "UNLOCKED" }];
  const [filterByStatus, setFilterByStatus] = useState(null);

  let count = 0;
  useEffect(() => {
    if (count === 0) {
      if (hasPermission(TIMESHEET_INVOICE_VIEW)) {
        fetchAllocatedProjectData();
      }
      count++;
    }
  }, []);

  /* Employee/Manager Allocated Project List Start */
  const fetchAllocatedProjectData = (param = {}) => {
    timesheetApi.getAllProjectByUser(param).then((resp) => {
      try {
        setAllocatedProjectData(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Employee/Manager Allocated Project List End */

  const getTimesheetTeamInvoice = (param = {}) => {
    timesheetApi.getTimesheetTeamInvoiceData(param).then((resp) => {
      try {
        setInvoiceTimesheetList(resp.data.data);
        setInvoiceFilterTimesheetList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const changeUserByProject = (e) => {
    setSelectedProject(e.value);
    var idList = [];
    e.value.map((item, key) => {
      idList[key] = item.id;
    })
    let param = {
      projectIds: idList
    }
    settingService.getUsersByProjectId(param).then((resp) => {
      try {
        var memberListing = [];
        resp.data.data.map((item) => {
          let objMember = {
            id: item.id,
            name: item.firstName.charAt(0).toUpperCase() + item.firstName.slice(1) + " " + item.lastName.charAt(0).toUpperCase() + item.lastName.slice(1),
          };
          memberListing.push(objMember);
        });
        setEmployeeList(memberListing);
      } catch (error) {
        // Error handle
      }
    });
  }

  const validateError = () => {
    if (selectedProject === null) {
      SetErrorLog(true);
      return true;
    }
  };

  const filterInvoiceByMonth = (e = null) => {
    setDateFilter(true);
    let d;
    if (e !== null) {
      setCurrMonth(e.value);
      d = new Date(e.value);
    } else {
      d = new Date(currMonth)
    }
    const now = new Date(d);
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const fd = moment(firstDay).format("DD");
    const ld = moment(lastDay).format("DD");
    const m = moment(d).format("MM");
    const y = moment(d).format("YYYY");
    let sDate = fd + "-" + m + "-" + y;
    let eDate = ld + "-" + m + "-" + y;
    setInvoiceSDate(sDate);
    setInvoiceEDate(eDate);
  }

  const filterUserInvoice = () => {
    let dateArr;
    let startDate;
    let endDate;
    let curr = new Date();
    if (dateFilter) {
      startDate = invoiceSDate;
      endDate = invoiceEDate;
    } else {
      dateArr = Util.invoiceDateConverter(curr);
      let dateObj = dateArr.split("/");
      startDate = dateObj[0];
      endDate = dateObj[1];
      setInvoiceSDate(startDate);
      setInvoiceEDate(endDate);
    }
    const error = validateError();
    if (error) {
    } else {
      let param = {};
      var projectList = [];
      selectedProject?.map((item, key) => {
        projectList[key] = item?.id;
      })
      if (selectedProject) {
        param.projectId = projectList;
        setProjectIdsList(projectList);
      }
      if (teamMember) {
        param.userId = teamMember.id;
      }
      param.fromDate = startDate;
      param.toDate = endDate;
      param.withActivity = false;
      param.isExport = false;
      param.sendEmail = false;
      timesheetApi.getTimesheetTeamInvoiceData(param).then((resp) => {
        try {
          setInvoiceTimesheetList(resp.data.data);
          setInvoiceFilterTimesheetList(resp.data.data);
          setExportDisabled(false);
        } catch (error) {
          // Error handle
        }
      });
    }
  };

  const downloadExcel = () => {
    var param = {};
    if (teamMember) {
      param.userId = teamMember.id;
    }

    if (selectedInvoiceTimesheet.length > 0) {
      var userIdList = [];
      selectedInvoiceTimesheet.map((item) => {
        userIdList.push(item.id);
      })
      param.userId = userIdList;
    }

    var projectListExcel = [];
    selectedProject?.map((item, key) => {
      projectListExcel[key] = item?.id;
    })
    if (selectedProject) {
      param.projectId = projectListExcel
    }
    param.fromDate = invoiceSDate;
    param.toDate = invoiceEDate;

    if (checked) {
      param.withActivity = true;
      param.isExport = true;
      param.sendEmail = false;
    }

    if (!checked) {
      param.withActivity = false;
      param.isExport = true;
      param.sendEmail = false;
    }
    timesheetApi.getTimesheetTeamInvoiceExcelData(param).then((resp) => {
      try {
        var blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, `${selectedProject?.title}(${param?.fromDate}-${param?.toDate})_INVOICE.xlsx`);
      } catch (error) {
        // Error handle
      }
    });
  };

  const mailIdList = (data) => {
    let emailInString = data.toString();
    let emailinreqFormat = emailInString.replace(/,/g, ";");
    setEmailPayload(emailinreqFormat);
  };

  const sendAsMail = () => {
    var param = {};
    if (teamMember) {
      param.userId = teamMember.id;
    }

    var projectListMail = [];
    selectedProject?.map((item, key) => {
      projectListMail[key] = item?.id;
    })
    if (selectedProject) {
      param.projectId = projectListMail;
    }
    param.fromDate = invoiceSDate;
    param.toDate = invoiceEDate;

    if (checked) {
      param.isExport = true;
      param.withActivity = true;
      param.sendEmail = true;
      param.email = emailPayload;
    }

    if (!checked) {
      param.isExport = true;
      param.withActivity = false;
      param.sendEmail = true;
      param.email = emailPayload;
    }
    timesheetApi.getTimesheetTeamInvoiceExcelData(param).then((resp) => {
      try {
        setEmailDialog(false);
        toast.info("Mail sent successfully!");
      } catch (error) {
        // Error handle
      }
    });
  };

  const getAllUsersEmail = (email) => {
    userService.getAllUsersEmail(email).then((resp) => {
      setAllUsersEmail(resp.data.data);
    });
  };

  const sendInvoiceEmail = () => {
    setEmailDialog(true);
    getAllUsersEmail();
  }

  const items = [
    { label: "EXCEL", icon: "pi pi-file-excel", command: () => { downloadExcel(); }, },
    { label: "SEND AS MAIL", icon: "pi pi-send", command: () => { sendInvoiceEmail() }, },
  ];

  const saveData = () => {
    sendAsMail();
    //call send mail API
  };

  const EmailDialog = () => {
    return (
      <Dialog header="Send Attachment as Mail" visible={emailDialog} style={{ width: "500px" }} onHide={() => onHide()}>
        <EmailDialogForm
          save={(data) => saveData(data)}
          onClose={(e) => { setEmailDialog(false); }}
          userData={allUsersEmail}//{allUsers}
          getUserEmail={getAllUsersEmail}
          mailIdListprop={mailIdList} //child to parent prop
        />
      </Dialog>
    );
  };


  const filterStatusData = (e) => {
    let filteredCategories;
    if (e?.value?.code === 'LOCKED') {
      filteredCategories = invoiceFilterTimesheetList.filter((el) => el.Timesheets[0].status === 'LOCKED');
    } else if (e?.value?.code === 'UNLOCKED') {
      filteredCategories = invoiceFilterTimesheetList.filter((el) => el.Timesheets[0].status === 'APPROVED');
    } else {
      filterUserInvoice();
    }
    setInvoiceTimesheetList(filteredCategories);
    setInvoiceFilterTimesheetList(invoiceTimesheetList)
    setFilterByStatus(e.value);
  }

  const InvoiceFilter = () => {
    return (
      <React.Fragment>
        <div style={{display: "flex", flexWrap: "wrap", alignItems:"center", gap:"15px", }} >
          <div className="inner_child">
            Filter :
          </div>
          <div className="showCalender">
            <MultiSelect filter value={selectedProject} options={allocatedProjectData} onChange={(e) => changeUserByProject(e)} optionLabel="title" placeholder="Select Project" maxSelectedLabels={1} showClear={false} style={{ width: "150px", height:"40px" }} className={classNames({ "p-invalid": errorLog && !selectedProject },)} />
            {errorLog && (
              <span>
                {selectedProject === null && (
                  <div style={{ color: "red" }}>Select Project!</div>
                )}
              </span>
            )}
          </div>
          <div className="inner_child">
            <Calendar value={currMonth} onChange={filterInvoiceByMonth} view="month" dateFormat="mm-yy" yearNavigator yearRange={"2010:" + new Date().getFullYear().toString()} showIcon />
          </div>
          <div className="inner_child">
            <Dropdown appendTo='self' showClear id="teamMember" name="teamMember" value={teamMember} options={employeeList} onChange={(e) => setTeamMember(e.value)} optionLabel="name" placeholder="Select Employees" style={{ width: "154px", height:"40px" }} filter />
          </div>

          <div className="inner_child">
            <Dropdown appendTo='self' showClear id="filterByStatus" name="filterByStatus" value={filterByStatus} options={filterStatusList} onChange={(e) => filterStatusData(e)} optionLabel="name" placeholder="Select Filter" style={{ width: "154px", height:"40px" }} filter />
          </div>

          <div className="showCalender">
            <Button label="Filter" className="p-button-rounded" icon="pi pi-search" type="button" onClick={filterUserInvoice} />
          </div>
        </div>
      </React.Fragment>
    );
  };

  const InvoiceButton = () => {
    return (
      <React.Fragment>
        {/* <Button label="Lock and Send Data to D365" className="p-button-rounded" icon="pi pi-lock" disabled={lockUnlockDisabled} onClick={() => lockedUnlockedInvoice("", "lockedall", "locked")} /> */}
        <Button label="Lock and Send Data to D365" className="p-button-rounded" icon="pi pi-lock" disabled={lockUnlockDisabled} onClick={() => lockedTimesheetInvoice("", "lockedall", "locked")} />

        <ProtectedSection permissions={[TIMESHEET_INVOICE_UNLOCK]}>
          <Button label="Unlock Records" className="p-button-rounded p-button-secondary ml-2" icon="pi pi-unlock"
            disabled={lockUnlockDisabled} onClick={() => unlockedTimesheetInvoice("", "unlockedall", "unlocked")} />
        </ProtectedSection>


        <SplitButton className="p-button-rounded ml-2" label="Export Locked Records" icon="pi pi-download" model={items} disabled={exportDisabled}></SplitButton>
        <Checkbox onChange={(e) => setChecked(e.checked)} checked={checked} style={{ marginLeft: 20 }}></Checkbox>
        <span style={{ marginLeft: 10 }}> <b>Include Activity Data</b> </span>
      </React.Fragment>
    );
  };

  const acceptFunc = () => {
    setMgrDialog(true);
  };
  const sendTimesheetForLock = (rowData, type, msg) => {
    const timesheets = Array.isArray(rowData) ? rowData : [rowData];
    // const invoiceStatus = timesheets.flatMap(ts => ts.Timesheets.map(e => e.timesheetProjects[0]?.isPosted));
    // let status = invoiceStatus.includes(true) ? "LOCKED" : "UNLOCKED";
    const invoiceStatus = timesheets.flatMap(item =>
      item.Timesheets.map(project => project?.timesheetProjects[0]?.isPosted === null ? false : project?.timesheetProjects[0]?.isPosted)
    );
    let status = invoiceStatus.every(value => value === true) ? "LOCKED" : "UNLOCKED";
    let formattedDate = Util.changeFormatInDayYear(invoiceSDate);
    let param = [];
    let lockedProjects;
    if (type === "locked") {
      let lockedTimesheetId = rowData.Timesheets.map((a) => a.id);
      param = [{ reason: "", period: formattedDate, projectIds: projectIdsList, status: "LOCKED", userId: rowData.id, timesheet: lockedTimesheetId, }];
      lockedProjects = rowData.Timesheets.filter((x) => {
        return x?.status == 'LOCKED';
      });
    }
    if (type === "lockedall") {

      param = selectedInvoiceTimesheet.map(item => {
        let timeSheetIdList = [];
        item.Timesheets.forEach(timesheet => {
          timeSheetIdList.push(timesheet.id);
        });
        return { reason: "", period: formattedDate, projectIds: projectIdsList, status: "LOCKED", userId: item.id, timesheet: timeSheetIdList };
      });

      lockedProjects = selectedInvoiceTimesheet.filter((x) => {
        return x?.Timesheets[0]?.status == 'LOCKED';
      });
    }
    try {
      if (status === 'LOCKED') {
        toast.error("You can not select locked records!");
      } else {
        timesheetApi.lockUnlockInvoiceTimesheet(param).then((resp) => {
          if (resp?.data?.success) {
            toast.success("Invoice " + msg + " successfully!");
            setSelectedInvoiceTimesheet(null);
            let param = {};
            if (teamMember) {
              param.userId = teamMember.id;
            }
            var projectList = [];
            selectedProject?.map((item, key) => {
              projectList[key] = item?.id;
            })
            if (selectedProject) {
              param.projectId = projectList;
            }
            param.fromDate = invoiceSDate;
            param.toDate = invoiceEDate;
            param.withActivity = false;
            param.isExport = false;
            param.sendEmail = false;
            getTimesheetTeamInvoice(param);
          } else {
            toast.error(resp?.data?.error);
          }
        },
          (err) => {
            toast.error("Unable to " + msg + " invoice!");
          }
        );
      }
    } catch (error) {
      toast.error("Unable to " + msg + " invoice!");
    }
  }


  const unlockedTimesheetInvoice = (rowData, type, msg) => {
    let formattedDate = Util.changeFormatInDayYear(invoiceSDate);
    let param;
    let unlockedProjects;
    if (type === "unlocked") {
      let lockedTimesheetId = rowData.Timesheets.map((a) => a.id);
      param = [{ reason: "", period: formattedDate, projectIds: projectIdsList, status: "APPROVED", userId: rowData.id, timesheet: lockedTimesheetId }];
      unlockedProjects = rowData.Timesheets.filter((x) => {
        return x?.status == "APPROVED";
      });
    }

    if (type === "unlockedall") {
      param = selectedInvoiceTimesheet.map(item => {
        let timeSheetIdList = [];
        item.Timesheets.forEach(timesheet => {
          timeSheetIdList.push(timesheet.id);
        });
        return { reason: "", period: formattedDate, projectIds: projectIdsList, status: "APPROVED", userId: item.id, timesheet: timeSheetIdList };
      });
      unlockedProjects = selectedInvoiceTimesheet.filter((x) => {
        return x?.Timesheets[0]?.status == "APPROVED";
      });
    }

    try {
      if (unlockedProjects.length > 0) {
        toast.error("You can not select unlocked records!");
      } else {
        timesheetApi.lockUnlockInvoiceTimesheet(param).then(
          (resp) => {
            if (resp?.data?.success) {
              toast.success("Invoice " + msg + " successfully!");
              setSelectedInvoiceTimesheet(null);
              let param = {};
              if (teamMember) {
                param.userId = teamMember.id;
              }
              var projectList = [];
              selectedProject?.map((item, key) => {
                projectList[key] = item?.id;
              })
              if (selectedProject) {
                param.projectId = projectList;
              }
              param.fromDate = invoiceSDate;
              param.toDate = invoiceEDate;
              param.withActivity = false;
              param.isExport = false;
              param.sendEmail = false;
              getTimesheetTeamInvoice(param);
            } else {
              toast.error(resp.data.error);
            }
          },
          (err) => {
            toast.error("Unable to " + msg + " invoice!");
          }
        );
      }
    } catch (error) {
      toast.error("Unable to " + msg + " invoice!");
    }
  };

  const lockedTimesheetInvoice = (rowData, type, msg) => {
    const selUserIds = selectedInvoiceTimesheet?.map(x => x.id);
    var proIds = selectedProject.map(obj => obj.id);
    let empParam = {
      month: currMonth.getMonth() + 1,
      year: currMonth.getFullYear(),
      projectIds: proIds,
      userIds: rowData ? [rowData.id] : selUserIds
    }
    timesheetApi.checkEmployessFilledTimesheet(empParam).then((resp) => {
      if (resp.data.data.length > 0) {
        setAllocationMessage(resp.data.data);
        confirmDialog({
          message: <p>You will not be able to Lock the Timesheet for this month as some users haven't filled their timesheets. <br /> To view the resources kindly click on the button below. <br /> You are requested to either ask your respective team members to fill the timesheet for the missing days or you can fill it yourself on their behalf.</p>,
          header: "Pending Timesheet Confirmation",
          icon: "pi pi-info-circle",
          acceptClassName: "p-button-danger",
          acceptLabel: 'View Resource',
          rejectLabel: 'Lock Records',
          accept: () => acceptFunc(),
          reject: () => sendTimesheetForLock(rowData ? rowData : selectedInvoiceTimesheet, type, msg),
        });
      } else {
        let param;
        let lockedProjects;
        let formattedDate = Util.changeFormatInDayYear(invoiceSDate);
        if (type === "locked") {
          let lockedTimesheetId = rowData.Timesheets.map((a) => a.id);
          param = [{ reason: "", period: formattedDate, projectIds: projectIdsList, status: "LOCKED", userId: rowData.id, timesheet: lockedTimesheetId, }];
          lockedProjects = rowData.Timesheets.filter((x) => {
            return x?.status == 'LOCKED';
          });
        }

        if (type === "lockedall") {
          param = selectedInvoiceTimesheet.map(item => {
            let timeSheetIdList = [];
            item.Timesheets.forEach(timesheet => {
              timeSheetIdList.push(timesheet.id);
            });
            return { reason: "", period: formattedDate, projectIds: projectIdsList, status: "LOCKED", userId: item.id, timesheet: timeSheetIdList };
          });

          lockedProjects = selectedInvoiceTimesheet.filter((x) => {
            return x?.Timesheets[0]?.status == 'LOCKED';
          });
        }
        try {
          if (lockedProjects.length > 0) {
            toast.error("You can not select locked records!");
          } else {
            timesheetApi.lockUnlockInvoiceTimesheet(param).then(
              (resp) => {
                if (resp?.data?.success) {
                  toast.success("Invoice " + msg + " successfully!");
                  setSelectedInvoiceTimesheet(null);
                  let param = {};
                  if (teamMember) {
                    param.userId = teamMember.id;
                  }
                  var projectList = [];
                  selectedProject?.map((item, key) => {
                    projectList[key] = item?.id;
                  })
                  if (selectedProject) {
                    param.projectId = projectList;
                  }
                  param.fromDate = invoiceSDate;
                  param.toDate = invoiceEDate;
                  param.withActivity = false;
                  param.isExport = false;
                  param.sendEmail = false;
                  getTimesheetTeamInvoice(param);
                } else {
                  toast.error(resp?.data?.error);
                }
              },
              (err) => {
                toast.error("Unable to " + msg + " invoice!");
              }
            );
          }
        } catch (error) {
          toast.error("Unable to " + msg + " invoice!");
        }
      }
    });
  };


  const onHidePendingDialog = () => {
    setMgrDialog(false);
  };
  const remaningBodyTemplate = (data) => {
    return (
      (data.twd) - (data.approvedDays)
    );
  };




  const PendingTimesheetDialog = () => {
    return (
      <Dialog
        className="pop-up-dialog custom_popup"
        header="Pending Timesheet Resource"
        visible={mgrDialog}
        onHide={() => onHidePendingDialog()}
        style={{ width: "50vw" }}
      >
        <DataTable resizableColumns columnResizeMode="fit" responsiveLayout="scroll" scrollable="horizontal" value={allocationMessage}>
          <Column field="ecn" header="ECN" sortable headerStyle={{ width: "12rem" }}></Column>
          <Column field="name" header="Name" sortable headerStyle={{ width: "12rem" }}></Column>
          <Column field="twd" header="Working Day" sortable headerStyle={{ width: "12rem" }}></Column>
          <Column field="approvedDays" header="Approved Day" sortable headerStyle={{ width: "8rem" }}></Column>
          <Column field="" header="Remaning Day" body={remaningBodyTemplate} sortable headerStyle={{ width: "8rem" }}></Column>
          <Column field="leaveDays" header="Leave Day" sortable headerStyle={{ width: "8rem" }}></Column>
        </DataTable>
      </Dialog>
    );
  };

  const onHide = () => {
    setInvoiceDetailsDialog(false);
    setEmailDialog(false);
  };

  const InvoiceDetailsDialog = (data, rowIndex) => {
    return (
      <Dialog className="pop-up-dialog custom_popup" header="Invoice Timesheet Details" visible={invoiceDetailsDialog} onHide={() => onHide()}>
        <Fieldset>
          <DataTable dataKey="id" value={data.Timesheets} responsiveLayout="scroll" onRowToggle={(e) => toggledChildInvoiceRow(e)} expandedRows={expandedChildInvoiceRows} rowExpansionTemplate={rowInvoiceChildExpansionTemplate}>
            <Column field="id" header="Id" style={{ minWidth: "15rem" }}></Column>
            <Column field="date" header="Date" style={{ minWidth: "15rem" }}></Column>
            <Column field="" header="Project" body={projectMainBodyTemplate}></Column> 
            <Column field="" header="Total Hours" body={projectHoursBodyTemplate}></Column>
            <Column expander style={{ width: "3em" }} />
          </DataTable>
        </Fieldset>
      </Dialog>
    );
  };

  const viewInvoiceDetails = (rowData, rowIndex) => {
    setInvoiceRowData(rowData);
    setInvoiceRowIndex(rowIndex);
    setInvoiceDetailsDialog(true);
  };

  const disabledLock = () => {
    // selectedInvoiceTimesheet.length>0
    setLockStatus(true);
  }

  const invoiceActionBodyTemplate = (rowData, rowIndex) => {
    return (
      <React.Fragment>
        {/* <Button icon="pi pi-lock" className="p-button-rounded p-button-danger" aria-label="Cancel" tooltip="Lock and Send Data to D365" tooltipOptions={{ position: "top" }} onClick={() => lockedUnlockedInvoice(rowData, "locked", "locked")} disabled={disabledLock} /> */}
        <Button icon="pi pi-lock" className="p-button-rounded p-button-danger" aria-label="Cancel" tooltip="Lock and Send Data to D365" tooltipOptions={{ position: "top" }} onClick={() => lockedTimesheetInvoice(rowData, "locked", "locked")} />
        {/* <Button icon="pi pi-unlock" className="p-button-rounded ml-2" aria-label="Filter" tooltip="Unlock Record" tooltipOptions={{ position: "top" }} onClick={() => unlockedTimesheetInvoice(rowData, "unlocked", "unlocked")} /> */}
        <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary ml-2" aria-label="View" tooltip="View Details" tooltipOptions={{ position: "top" }} onClick={() => viewInvoiceDetails(rowData, rowIndex)} />
      </React.Fragment>
    );
  };

  const fetchStatusColor = (status) => {
    if (status === "LOCKED") return "red";
    if (status === "UNLOCKED") return "green";
  };

  const invoiceBodyTemplate = (rowData, type) => {
    switch (type) {
      case "name":
        return rowData.name;
      case "designation":
        return rowData.designation;
      case "bu":
        return rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails
          ?.businessUnits?.title;
      case "client":
        return rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails
          ?.cust?.title;
      case "projectCode":
        return rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails
          ?.code;
      case "projectType":
        return rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails
          ?.projectTypes?.title;
      case "timesheetDateRange":
        let dateRangeList = [];
        rowData.Timesheets.map((el) => {
          dateRangeList.push(el?.date);
        });
        let dateListRange = dateRangeList.sort();
        return dateListRange[0] + " - " + dateListRange[dateListRange.length - 1];
      case "project":
        let proName = [];
        rowData.Timesheets.map((el) => {
          el.timesheetProjects.map((e) => {
            proName.push(e.projectDetails.title);
          });
        });
        let proNameUnique = Array.from(new Set(proName));
        return <p>{proNameUnique.join(", ")}</p>;
      case "status":
        const allProjects = rowData.Timesheets.flatMap(
          ts => ts.timesheetProjects
        );

        const validProjects = allProjects.filter(
          project =>
            project?.categories?.code !== "OC" &&
            project?.categories?.code !== "OCD"
        );

        const status =
          validProjects.length === 0 ||
            validProjects.every(project => project.isPosted === true)
            ? "LOCKED"
            : "UNLOCKED";

        return (
          <span style={{ color: fetchStatusColor(status), borderRadius: "8px", fontSize: "12px", fontWeight: "700", }}
          > {status} </span>
        );
      case "totalDays":
        return (
          <div style={{ marginLeft: "15px" }}>
            <strong style={{ color: "#bb86fc" }}>{rowData.Timesheets.length}</strong>
          </div>
        );
      case "invoiceDays":
        let totDays = rowData.Timesheets.length;
        let lhDays = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            if (rowData.Timesheets[i].timesheetProjects[j].categories?.code === "LH") {
              lhDays += rowData.Timesheets[i].timesheetProjects[j].hours ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
            }
          }
        }
        let invDays = totDays - (lhDays / 8);
        return (
          <div style={{ marginLeft: "15px" }}>
            <strong style={{ color: "#bb86fc" }}>{invDays}</strong>
          </div>
        );
      case "leaveDays":
        let leaveDays = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            if (rowData.Timesheets[i].timesheetProjects[j].categories?.code === "LH") {
              leaveDays += rowData.Timesheets[i].timesheetProjects[j].hours ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
            }
          }
        }
        return (
          <div style={{ marginLeft: "15px" }}>
            <strong style={{ color: "#bb86fc" }}>{leaveDays / 8}</strong>
          </div>
        );
      case "otHours":
        let oTtotal = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            if (rowData.Timesheets[i].timesheetProjects[j].categories?.code === "OT") {
              oTtotal += rowData.Timesheets[i].timesheetProjects[j].hours ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
            }
          }
        }
        return (
          <div style={{ marginLeft: "15px" }}>
            <strong style={{ color: "#4cd964" }}>{oTtotal?.toFixed(2)}</strong>
          </div>
        );
      case "leaveHours":
        let leaveTotal = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            if (rowData.Timesheets[i].timesheetProjects[j].categories?.code === "LH") {
              leaveTotal += rowData.Timesheets[i].timesheetProjects[j].hours ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
            }
          }
        }
        return (
          <div style={{ marginLeft: "15px" }}>
            <strong style={{ color: "#4cd964" }}>{leaveTotal?.toFixed(2)}</strong>
          </div>
        );
      case "hours":
        let oTHours = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            if (rowData.Timesheets[i].timesheetProjects[j].categories?.code === "OT") {
              oTHours += rowData.Timesheets[i].timesheetProjects[j].hours ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
            }
          }
        }
        let lHHours = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            if (rowData.Timesheets[i].timesheetProjects[j].categories?.code === "LH") {
              lHHours += rowData.Timesheets[i].timesheetProjects[j].hours ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
            }
          }
        }
        let totalHours = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            totalHours += rowData.Timesheets[i].timesheetProjects[j].hours ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
          }
        }
        let odinaryHours = totalHours - oTHours - lHHours;
        return (
          <div style={{ marginLeft: "15px" }}>
            <strong style={{ color: "#4cd964" }}>{odinaryHours?.toFixed(2)}</strong>
          </div>
        );
      case "totalHours":
        let total = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            total += rowData.Timesheets[i].timesheetProjects[j].hours ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
          }
        }
        return (
          <div style={{ marginLeft: "15px" }}><strong style={{ color: "#4cd964" }}>{total?.toFixed(2)}</strong></div>
        );
      case "billableHours":
        let totalBillableHours = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            totalBillableHours += rowData.Timesheets[i].timesheetProjects[j].isBillable ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
          }
        }
        return (
          <div style={{ marginLeft: "15px" }}><strong style={{ color: "#4cd964" }}>{totalBillableHours?.toFixed(2)}</strong></div>
        );
      case "nonBillableHours":
        let totalNonBillableHours = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          for (
            let j = 0;
            j < rowData.Timesheets[i].timesheetProjects.length;
            j++
          ) {
            totalNonBillableHours += !rowData.Timesheets[i].timesheetProjects[j].isBillable ? rowData.Timesheets[i].timesheetProjects[j].hours : 0;
          }
        }
        return (
          <div style={{ marginLeft: "15px" }}><strong style={{ color: "#4cd964" }}>{totalNonBillableHours?.toFixed(2)}</strong></div>
        );
      default:
        return "";
    }
  };

  const toggledChildInvoiceRow = (e) => {
    if (expandedChildInvoiceRows !== null) {
      Reflect.deleteProperty(e.data, Object.keys(expandedChildInvoiceRows)[0]);
    }
    setExpandedChildInvoiceRows({ [`${Object.keys(e.data)[0]}`]: true });
  };

  const projectHoursBodyTemplate = (rowData) => {
    let totalHours = 0;
    for (let i = 0; i < rowData.timesheetProjects.length; i++) {
      totalHours += rowData.timesheetProjects[i].hours ? rowData.timesheetProjects[i].hours : 0;
    }
    return (
      <div style={{ marginLeft: "15px" }}>
        <strong>{totalHours?.toFixed(2)}</strong>
      </div>
    );
  }

  const hoursRoundOffTemplate = (item) => {
    return item.hours?.toFixed(2);
  };

  const rowInvoiceChildExpansionTemplate = (data) => {
    return (
      <div className="orders-subtable">
        <DataTable value={data.timesheetProjects} responsiveLayout="scroll">
          <Column field="categoryId" header="Category" style={{ minWidth: "8rem" }} body={(e) => childExpansionBodyTemplate(e, "category")}></Column>
          <Column field="activityId" header="Activity" style={{ minWidth: "8rem" }} body={(e) => childExpansionBodyTemplate(e, "activity")}></Column>
          <Column field="jiraTaskId" header="JIRA / Task ID" style={{ minWidth: "8rem" }}></Column>
          <Column field="description" header="Description" style={{ minWidth: "8rem" }}></Column>
          <Column field="" header="Hours" body={hoursRoundOffTemplate} style={{ minWidth: "8rem" }}></Column>
        </DataTable>
      </div>
    );
  };

  const projectMainBodyTemplate = (rowData) => {
    let proName = [];
    rowData.timesheetProjects.map((el) => {
      proName.push(el.projectDetails.title);
    });
    let proNameUnique = Array.from(new Set(proName));
    return <p>{proNameUnique.join(", ")}</p>;
  };

  const childExpansionBodyTemplate = (rowData, type) => {
    switch (type) {
      case "project":
        return rowData.projectDetails ? rowData.projectDetails.title : "";
      case "category":
        return rowData.categories ? rowData.categories.title : "";
      case "activity":
        return rowData.activities ? rowData.activities.title : "";
      default:
        return "";
    }
  };

  const selectInvoice = (e) => {
    setSelectedInvoiceTimesheet(e.value);
    e.value.length > 0 ? setLockUnlockDisabled(false) : setLockUnlockDisabled(true);
  };

  return (
    <>
      {EmailDialog()}
      {InvoiceDetailsDialog(invoiceRowData, invoiceRowIndex)}
      <Toolbar className="mb-4" left={InvoiceFilter} right={InvoiceButton}></Toolbar>
      <DataTable dataKey="invId" paginator responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]} resizableColumns columnResizeMode="fit" scrollable="horizontal"
        stripedRows ref={dt} selectionMode={rowClick ? null : "checkbox"} value={invoiceTimesheetList}
        selection={selectedInvoiceTimesheet} onSelectionChange={(e) => selectInvoice(e)}>
        <Column selectionMode="multiple" headerStyle={{ minWidth: "2rem" }} exportable={false}></Column>
        <Column field="ecn" header="ECN" headerStyle={{ minWidth: "5rem" }} ></Column>
        <Column field="name" header="Name" className="capitalize" headerStyle={{ minWidth: "13rem" }} body={(e) => invoiceBodyTemplate(e, "name")}></Column>
        <Column field="" header="Designation" style={{ minWidth: "15rem" }} body={(e) => invoiceBodyTemplate(e, "designation")}></Column>
        <Column field="region" header="Region" style={{ minWidth: "10rem" }}></Column>
        <Column field="" header="BU" body={(e) => invoiceBodyTemplate(e, "bu")} style={{ minWidth: "10rem" }}></Column>
        <Column field="" header="Client" body={(e) => invoiceBodyTemplate(e, "client")} style={{ minWidth: "10rem" }}></Column>
        <Column field="" header="Project Code" style={{ minWidth: "10rem" }} body={(e) => invoiceBodyTemplate(e, "projectCode")}></Column>
        <Column field="project" header="Project Name" style={{ minWidth: "25rem" }} body={(e) => invoiceBodyTemplate(e, "project")}></Column>
        <Column field="" header="Project Type" body={(e) => invoiceBodyTemplate(e, "projectType")} style={{ minWidth: "10rem" }}></Column>
        <Column field="" header="Timesheet Range" style={{ minWidth: "15rem" }} body={(e) => invoiceBodyTemplate(e, "timesheetDateRange")}></Column>
        <Column field="totalDays" header="Filled Days" style={{ minWidth: "10rem" }} body={(e) => invoiceBodyTemplate(e, "totalDays")}></Column>
        <Column field="invoiceDays" header="Invoice Days" style={{ minWidth: "10rem" }} body={(e) => invoiceBodyTemplate(e, "invoiceDays")}></Column>
        <Column field="leaveDays" header="Leave Days" style={{ minWidth: "10rem" }} body={(e) => invoiceBodyTemplate(e, "leaveDays")}></Column>
        <Column field="" header="OT Hours" style={{ minWidth: "10rem" }} body={(e) => invoiceBodyTemplate(e, "otHours")}></Column>
        <Column field="" header="Leave Hours" style={{ minWidth: "10rem" }} body={(e) => invoiceBodyTemplate(e, "leaveHours")}></Column>
        <Column field="" header="Working Hours" body={(e) => invoiceBodyTemplate(e, "hours")} style={{ minWidth: "10rem" }}></Column>

        <Column field="" header="Billable Hours" body={(e) => invoiceBodyTemplate(e, "billableHours")} style={{ minWidth: "10rem" }}></Column>
        <Column field="" header="Non-Billable Hours" body={(e) => invoiceBodyTemplate(e, "nonBillableHours")} style={{ minWidth: "10rem" }}></Column>


        <Column field="totalHours" header="Total Hours" style={{ minWidth: "10rem" }} body={(e) => invoiceBodyTemplate(e, "totalHours")}></Column>
        <Column field="status" header="Status" body={(e) => invoiceBodyTemplate(e, "status")} style={{ minWidth: "10rem" }}></Column>
        <Column field="" header="Action" body={invoiceActionBodyTemplate} style={{ minWidth: "15rem" }}></Column>
      </DataTable>
      {PendingTimesheetDialog()}
    </>
  );
};

export default InvoiceTimesheet;